<template>
  <div>
  	<h2 class="title is-2">
  		<router-link to="/tools/history">
  			<b-icon icon="chevron-left" size="is-small"></b-icon>
  		</router-link> &nbsp;
  		History Item
  	</h2>
  	<div class="box" v-if="item">
  		<p class="title is-3">Relation</p>
      <p class="subtitle is-6">{{item.controller}}</p>

      <p class="title is-3">Action</p>
      <p class="subtitle is-6">{{item.action}}</p>

      <p class="title is-3">User</p>
      <p class="subtitle is-6">{{item.user}}</p>

      <p class="title is-3">Timestamp</p>
      <p class="subtitle is-6">{{item.created_at}}</p>

      <hr>

      <tree-view :data="JSON.parse(item.payload)" :options="{rootObjectKey: 'Payload'}"></tree-view>

  	</div>
  	<div class="box" v-else>
  		Could not find the entry.
  	</div>
  </div>	
</template>

<script>
	export default{
		name: "HistorySingle",
		computed: {
			data(){
				return this.$store.state.history.data;
			},
			item(){
				const { data } = this;
				if(!data){
					return null;
				}

				const filteredEntries = data.filter(x => x._id === this.$route.params.id);
				return filteredEntries.length > 0 ? filteredEntries[0] : null;
			}
		}
	}
</script>